import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { EditRlCOLineEntity } from "../entities/edit-co-line.entity";
import { coLineRequest, RLOrderFilter } from "@project-management-system/shared-models";



@Injectable()
export class EditRlCOLineRepository extends Repository<EditRlCOLineEntity> {

  constructor(@InjectRepository(EditRlCOLineEntity) private editrlCoLineRepository: Repository<EditRlCOLineEntity>
  ) {
    super(editrlCoLineRepository.target, editrlCoLineRepository.manager, editrlCoLineRepository.queryRunner);
  }

  async getEditCoLineData(req: RLOrderFilter): Promise<any[]> {
    const query = this.createQueryBuilder('co')
      .select(`DISTINCT co.po_number,co.po_item,co.material,co.co_date, co.item_no, co.item_status, co.error_msg,
                 DATE_FORMAT(co.created_at, '%m/%d/%Y %H:%i') as raised_date, co.created_user, co.co_number,co.id`);

    if (req.poNumber !== undefined) {
      query.andWhere(`co.po_number = :poNumber`, { poNumber: req.poNumber });
    }
    if (req.itemNo !== undefined) {
      query.andWhere(`co.item_no = :itemNo`, { itemNo: req.itemNo });
    }

    if (req.coNumber !== undefined) {
      query.andWhere(`co.co_number LIKE :coNumber`, { coNumber: `%${req.coNumber}%` });
    }

    return await query.getRawMany();
  }



//   async getEditCoPoNumber(): Promise<any[]> {
//     const query = this.createQueryBuilder('co')
//       .select(`co.id,co.po_number`)
//       .groupBy(`co.po_number`)
//     //  .where(`buyer_po <> NULL`)
//     return await query.getRawMany();
//   }
//   async getEditItem(): Promise<any[]> {
//     const query = this.createQueryBuilder('co')
//       .select(`co.id,co.item_no`)
//       .groupBy(`co.item_no`)
//     //  .where(`item_no <> NULL`)
//     return await query.getRawMany();
//   }


//   //   async getDataforCOLineCreation(): Promise<any[]> {
//   //       const query = this.createQueryBuilder('co')
//   //           .select(`co.id, co.po_number, co.item_no, co.buyer,co.po_line`)
//   //           .where(` status != 'Success' AND status != 'Inprogress' AND is_active = true`)
//   //           .orderBy(` created_at`, 'ASC')
//   //       return await query.getRawMany();
//   //   }

    async getDataforCOLineEdit(): Promise<any> {
      const query = this.createQueryBuilder('co')
          .select(`co.id, co.po_number,co.buyer,co.item_no,co.po_item,co.co_number,co.co_date`)
          .where(` item_status = 'OPEN'  AND is_active = true`)
          .orderBy(` created_at`, 'ASC')
      return await query.getRawOne();
  }




}